__turbopack_context__.v({
  "activeCardSlide": "storiesSlider-module-scss-module__HaDSha__activeCardSlide",
  "activeSlide": "storiesSlider-module-scss-module__HaDSha__activeSlide",
  "content": "storiesSlider-module-scss-module__HaDSha__content",
  "image": "storiesSlider-module-scss-module__HaDSha__image",
  "name": "storiesSlider-module-scss-module__HaDSha__name",
  "position": "storiesSlider-module-scss-module__HaDSha__position",
  "slide": "storiesSlider-module-scss-module__HaDSha__slide",
  "sliderWrapper": "storiesSlider-module-scss-module__HaDSha__sliderWrapper",
  "swiper": "storiesSlider-module-scss-module__HaDSha__swiper",
  "text": "storiesSlider-module-scss-module__HaDSha__text",
  "textFading": "storiesSlider-module-scss-module__HaDSha__textFading",
  "title": "storiesSlider-module-scss-module__HaDSha__title",
});
